<template>
    <div style="height: 100%">
        <component :is="currentLayoutComponent"
                   :d2adminState="d2adminState"
                   :d2adminThemeActiveSetting="d2adminThemeActiveSetting"
                   :d2adminKeepAliveInclude="d2adminKeepAliveInclude"
                   :isShowBreadcrumb="isShowBreadcrumb"
                   :logoTitle="logoTitle"
                   :bigScreenRouterPath="bigScreenRouterPath"
                   :isShowBigScreen="isShowBigScreen"
                   :isShowLogoImg="isShowLogoImg"
                   :isHeaderUpdatePwd="isHeaderUpdatePwd"
                   :isShowMenuHeader="isShowMenuHeader"
                   @d2adminMenuAsideCollapseToggle="d2adminMenuAsideCollapseToggle"
                   @d2adminFullScreenToggle="d2adminFullScreenToggle"
                   @d2adminTagCloseLeft="d2adminTagCloseLeft"
                   @d2adminTagCloseRight="d2adminTagCloseRight"
                   @d2adminTagCloseOther="d2adminTagCloseOther"  
                   @d2adminTagCloseAll="d2adminTagCloseAll"
                   @d2adminTagClose="d2adminTagClose"
                   @d2adminThemeSet="d2adminThemeSet"
                   @d2adminLogout="d2adminLogout"
        ></component>

        <!--<zebra-layout-d2admin v-if="layoutType==0"
                              :d2adminState="d2adminState"
                              :d2adminThemeActiveSetting="d2adminThemeActiveSetting"
                              :d2adminKeepAliveInclude="d2adminKeepAliveInclude"
                              :isShowBreadcrumb="isShowBreadcrumb"
                              :logoTitle="logoTitle"
                              :bigScreenRouterPath="bigScreenRouterPath"
                              :isShowBigScreen="isShowBigScreen"
                              @d2adminMenuAsideCollapseToggle="d2adminMenuAsideCollapseToggle"
                              @d2adminFullScreenToggle="d2adminFullScreenToggle"
                              @d2adminTagCloseLeft="d2adminTagCloseLeft"
                              @d2adminTagCloseRight="d2adminTagCloseRight"
                              @d2adminTagCloseOther="d2adminTagCloseOther"
                              @d2adminTagCloseAll="d2adminTagCloseAll"
                              @d2adminTagClose="d2adminTagClose"
                              @d2adminThemeSet="d2adminThemeSet"
                              @d2adminLogout="d2adminLogout"
        />
        <zebra-layout v-else-if="layoutType==1"/>
        <zebra-layout-public v-else-if="layoutType==2"/>
        <zebra-layout-angular v-else-if="layoutType==3"/>
        <zebra-layout-gg v-else-if="layoutType==4"
                         :d2adminState="d2adminState"
                         :d2adminThemeActiveSetting="d2adminThemeActiveSetting"
                         :d2adminKeepAliveInclude="d2adminKeepAliveInclude"
                         :isShowBreadcrumb="isShowBreadcrumb"
                         :logoTitle="logoTitle"
                         :bigScreenRouterPath="bigScreenRouterPath"
                         :isShowBigScreen="isShowBigScreen"
                         @d2adminMenuAsideCollapseToggle="d2adminMenuAsideCollapseToggle"
                         @d2adminFullScreenToggle="d2adminFullScreenToggle"
                         @d2adminTagCloseLeft="d2adaminTagCloseLeft"
                         @d2adminTagCloseRight="d2adminTagCloseRight"
                         @d2adminTagCloseOther="d2adminTagCloseOther"
                         @d2adminTagCloseAll="d2adminTagCloseAll"
                         @d2adminTagClose="d2adminTagClose"
                         @d2adminThemeSet="d2adminThemeSet"
                         @d2adminLogout="d2adminLogout"
        />
        <zebra-layout v-else/>-->
    </div>
</template>

<script>
    import setting from '@/setting.js'
    import ResizeMixin from './../../layout/mixin/ResizeHandler'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    //import ZebraLayoutPublic from "./layout-public-component";
    /*let layout = function () {
        // 布局模式，默认值1
        // 0-经典布局
        // 1-适合内网管理系统的布局
        // 2-适合门户网站的布局
        // 3-与公司原Angular版本相似的布局
        // 4-Guoguan项目定制布局
        if(setting.layout.layoutType==1){
            return import('@/layout/header-aside')
        }else if(setting.layout.layoutType==2){
            return import('@/layout/header-aside/layout-public')
        }else if(setting.layout.layoutType==0){
            return import('@/layout/header-aside/layout-d2admin')
        }else if(setting.layout.layoutType==3){
            return import('@/layout/header-aside/layout-eversec-angular')
        }else if(setting.layout.layoutType==4){
            return import('@/layout/header-aside/layout-gg')
        }else{
            // 适合内网管理系统的布局
            return import('@/layout/header-aside')
        }
    }*/
    export default {
        name: "auto-layout",
        components: {
            'ZebraLayoutPublic': () => import('./layout-public-component'),
            'ZebraLayout': () => import('./layout'),
        },
        mixins: [ResizeMixin],
        data(){
            return {
                // 当前激活的布局组件名称（技术原理：动态组件）
                //currentLayoutComponent: 'zebra-layout-d2admin',
                layoutMap: {
                    1: 'ZebraLayout',
                    2: 'ZebraLayoutPublic',
                },
                // 路径参数layout指定布局 比 配置文件中指定的布局 优先级高！
                //layoutType: this.$route.query.layout?this.$route.query.layout:setting.layout.layoutType,
                // 面包屑
                isShowBreadcrumb: setting.layout.isShowBreadcrumb,
                // Logo文字内容
                logoTitle: process.env.VUE_APP_TITLE,
                // 是否显示大屏页入口按钮
                isShowBigScreen: setting.layout.isShowBigScreen,
                // 是否显示logo图片部分
                isShowLogoImg: setting.layout.isShowLogoImg,
                // 大屏页面路径
                bigScreenRouterPath: setting.layout.bigScreenRouterPath,
                // 是否顶部开启修改密码入口（默认开启）
                isHeaderUpdatePwd: setting.layout.isHeaderUpdatePwd,
                // 是否显示顶部菜单
                isShowMenuHeader: setting.layout.isShowMenuHeader
            }
        },
        computed: {
            ...mapState({
                d2adminState: state => state.d2admin
                // isGrayMode: state => state.d2admin.isGrayMode,
                // pageOpenedList: state => state.d2admin.pageOpenedList,
                // isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse,
                // isFullScreen: state => state.d2admin.isFullScreen,
                // menuHeader: state => state.d2admin.menuHeader,
                // menuAside: state => state.d2admin.menuAside,
                // currentAppInfo: state => state.d2admin.currentAppInfo,
                // pageCurrent: state => state.d2admin.pageCurrent,
                // userInfo: state => state.d2admin.userInfo,
                // themeList: state => state.d2admin.themeList,
                // themeActiveName: state => state.d2admin.themeActiveName
            }),
            ...mapGetters([
                'd2adminThemeActiveSetting',
                'd2adminKeepAliveInclude'
            ]),
            /**
             * @description 最外层容器的背景图片样式
             */
            styleLayoutMainGroup () {
                return {
                    ...this.d2adminThemeActiveSetting.backgroundImage ? {
                        backgroundImage: `url('${this.$baseUrl}${this.d2adminThemeActiveSetting.backgroundImage}')`
                    } : {}
                }
            },
            /**
             * 获取对应的布局组件名称
             */
            currentLayoutComponent(){
                let currentLayoutComponent = this.layoutMap[this.layoutType]
                if(currentLayoutComponent){
                    console.log('提示：匹配到有效布局，使用布局渲染', currentLayoutComponent)
                    return currentLayoutComponent
                }else{
                    console.log('提示：未匹配到有效布局，使用默认布局渲染')
                    return this.layoutMap[1] //默认布局1-适合内网管理系统的布局
                }
            },
            /**
             * 获取布局类型
             */
            layoutType(){
                /*if(this.$route.query.layout){
                    return this.$route.query.layout
                }else if(util.cookies.get('LoginLayoutType')){
                    return util.cookies.get('LoginLayoutType')
                }else */
                if(this.d2adminState.urlParamInfo && this.d2adminState.urlParamInfo.layout){
                    console.log('检测到vuex中urlParamInfo.layout值:',this.d2adminState.urlParamInfo.layout)
                    return this.d2adminState.urlParamInfo.layout
                }else{
                    return setting.layout.layoutType
                }
            }
        },
        methods: {
            ...mapMutations([
                'd2adminMenuAsideCollapseToggle',
                'd2adminFullScreenToggle',
                'd2adminTagCloseLeft',
                'd2adminTagCloseRight',
                'd2adminTagCloseOther',
                'd2adminTagCloseAll',
                'd2adminTagClose',
                'd2adminThemeSet'
            ]),
            ...mapActions([
                'd2adminLogout'
            ]),
            /**
             * 接收点击切换侧边栏的按钮
             */
            handleToggleAside () {
                this.d2adminMenuAsideCollapseToggle()
            },
            handleSelectTheme(name) {
                this.d2adminThemeSet(name)
            },
            /**
             * @description 登出
             */
            logOff () {
                this.d2adminLogout({ 
                    vm: this,
                    confirm: true
                })
            }
        }
    }
</script>

<style lang="scss">
    // 注册主题
    @import '../../assets/style/theme/register.scss';
    // 注册主题（只用于手机布局）
    @import './../../assets/style/theme/mobile.scss';
</style>
